export default __webpack_public_path__ + "static/media/ts.f8c463ad.png";